import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-0" }
const _hoisted_2 = { class: "flex items-center justify-between border-b border-gray-200 pb-6 mb-6" }
const _hoisted_3 = { class: "text-2xl font-semibold text-gray-800" }
const _hoisted_4 = {
  key: 0,
  class: "text-slate-500"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_7 = { class: "bg-red-50 border border-red-200 rounded-lg p-6 max-w-md" }
const _hoisted_8 = { class: "text-red-700 text-sm" }
const _hoisted_9 = {
  key: 2,
  class: "space-y-4"
}
const _hoisted_10 = { class: "border rounded-lg overflow-hidden bg-white shadow-sm" }
const _hoisted_11 = { class: "overflow-x-auto" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = { class: "divide-y divide-gray-200" }
const _hoisted_14 = { class: "px-4 py-3" }
const _hoisted_15 = { class: "text-sm font-mono text-gray-700" }
const _hoisted_16 = { class: "px-4 py-3" }
const _hoisted_17 = { class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-200 text-slate-800" }
const _hoisted_18 = { class: "px-4 py-3" }
const _hoisted_19 = { class: "text-sm text-gray-900 font-medium" }
const _hoisted_20 = { class: "px-4 py-3" }
const _hoisted_21 = { class: "text-sm text-gray-900 font-medium" }
const _hoisted_22 = { class: "px-4 py-3" }
const _hoisted_23 = { class: "text-sm text-gray-700" }
const _hoisted_24 = { class: "px-4 py-3" }
const _hoisted_25 = { class: "text-sm text-gray-700" }
const _hoisted_26 = { class: "px-4 py-3" }
const _hoisted_27 = { class: "text-sm text-gray-700" }
const _hoisted_28 = { class: "px-4 py-3" }
const _hoisted_29 = { class: "text-sm text-gray-700" }
const _hoisted_30 = { class: "px-4 py-3" }
const _hoisted_31 = { class: "text-sm text-gray-700" }
const _hoisted_32 = { class: "px-4 py-3" }
const _hoisted_33 = { class: "text-xs px-2.5 py-0.5 bg-slate-100 rounded-full" }
const _hoisted_34 = { class: "px-4 py-3" }
const _hoisted_35 = { class: "px-4 py-3" }
const _hoisted_36 = { class: "flex items-center justify-between px-4 py-3 bg-white border rounded-lg" }
const _hoisted_37 = { class: "text-sm text-gray-700" }
const _hoisted_38 = { class: "flex items-center gap-2" }
const _hoisted_39 = { class: "flex gap-1" }
const _hoisted_40 = {
  key: 3,
  class: "flex flex-col items-center justify-center py-20"
}

import { Button } from '@/components/ui/button';
import { useFetchTransactions } from '@/hooks/use-transactions';
import { useTransactionStore } from '@/store/use-transaction-store';
import { type Transaction } from '@/types/transaction';
import { formatDate } from '@/utils/utils';
import { ChevronLeft, ChevronRight, Download } from 'lucide-vue-next';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';


// Get store

export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionsView',
  setup(__props) {

const transactionStore = useTransactionStore()

// Get reactive reference to transactionType from store
const { transactionType } = storeToRefs(transactionStore)

// Fetch transactions with transactionType from store
const { data: transactions, isLoading, isError, error } = useFetchTransactions(transactionType.value)

// Pagination
const currentPage = ref(1)
const itemsPerPage = ref(15)

const totalPages = computed(() => 
  Math.ceil((transactions.value?.length || 0) / itemsPerPage.value)
)

const paginatedData = computed(() => {
  if (!transactions.value) return []
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return transactions.value.slice(start, end)
})

const goToPage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
  }
}

// TODO: Think move this to the Backend. CSV Download
const downloadCSV = () => {
  if (!transactions.value || transactions.value.length === 0) {
    alert('No data to download')
    return
  }

  // Define CSV headers
  const headers = [
    'Membership Number',
    'Scheme Code',
    'Option Code',
    'Option Name',
    'Dependent Code',
    'Names',
    'Surname',
    'Date Enrolled',
    'Transaction Date',
    'Status',
    'Description'
  ]

  // Extract data rows
  const rows = transactions.value.map((tx: Transaction) => [
    tx?.meta_data?.membership_number,
    tx?.meta_data?.scheme_code,
    tx?.meta_data?.option_code,
    tx?.meta_data?.option_name,
    tx?.meta_data?.dependant_code,
    tx?.meta_data?.health_seeker?.first_name,
    tx?.meta_data?.health_seeker?.surname,
    tx?.meta_data?.date_enrolled,
    formatDate(tx?.created),
    tx?.status,
    tx?.status_description
  ])

  // Create CSV content
  const csvContent = [
    headers.join(','),
    ...rows.map(row => 
      row.map(cell => {
        // Escape cells that contain commas or quotes
        if (typeof cell === 'string' && (cell.includes(',') || cell.includes('"'))) {
          return `"${cell.replace(/"/g, '""')}"`
        }
        return cell
      }).join(',')
    )
  ].join('\n')

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  
  link.setAttribute('href', url)
  link.setAttribute('download', `transactions_${new Date().toISOString().split('T')[0]}.csv`)
  link.style.visibility = 'hidden'
  
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, [
          _createTextVNode(_toDisplayString(_unref(transactionType)?.replace(/_/g, ' ').toUpperCase()) + " Transactions ", 1),
          (_unref(transactions)?.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(_unref(transactions).length) + ") ", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_unref(Button), {
        onClick: downloadCSV,
        disabled: !_unref(transactions) || _unref(transactions).length === 0 || _unref(isLoading),
        class: "bg-[#255f7a] text-white hover:bg-[#225f7b]"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Download), { class: "mr-2 h-4 w-4" }),
          _cache[2] || (_cache[2] = _createTextVNode(" Download Report ", -1))
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-slate-600 mb-4" }, null, -1),
          _createElementVNode("p", { class: "text-lg text-gray-600 font-medium" }, "Loading transactions...", -1)
        ]))]))
      : (_unref(isError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-lg font-semibold text-red-900 mb-3" }, "Error Loading Data", -1)),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(error)?.message || 'Failed to load transactions'), 1)
            ])
          ]))
        : (_unref(transactions) && _unref(transactions).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("table", _hoisted_12, [
                    _cache[5] || (_cache[5] = _createElementVNode("thead", { class: "bg-gray-50 border-b" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Membership Number "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Scheme "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Option Code "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Option Name "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Dep Code "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Names "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Surname "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Date Enrolled "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Trans Date "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Trans Type "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Status "),
                        _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Status Description ")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (transaction) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: transaction?.id,
                          class: "hover:bg-gray-50 transition-colors"
                        }, [
                          _createElementVNode("td", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(transaction?.meta_data?.membership_number), 1)
                          ]),
                          _createElementVNode("td", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(transaction?.meta_data?.scheme_code), 1)
                          ]),
                          _createElementVNode("td", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(transaction?.meta_data?.option_code), 1)
                          ]),
                          _createElementVNode("td", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(transaction?.meta_data?.option_name), 1)
                          ]),
                          _createElementVNode("td", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(transaction?.meta_data?.dependant_code), 1)
                          ]),
                          _createElementVNode("td", _hoisted_24, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(transaction?.meta_data?.health_seeker?.first_name), 1)
                          ]),
                          _createElementVNode("td", _hoisted_26, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(transaction?.meta_data?.health_seeker?.surname), 1)
                          ]),
                          _createElementVNode("td", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(transaction?.meta_data?.date_enrolled), 1)
                          ]),
                          _createElementVNode("td", _hoisted_30, [
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(formatDate)(transaction?.created)), 1)
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(transaction?.transaction_type.toUpperCase()), 1)
                          ]),
                          _createElementVNode("td", _hoisted_34, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                      'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
                      transaction?.status === 'success'
                        ? 'bg-green-100 text-green-800'
                        : transaction?.status === 'pending'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-red-100 text-red-800'
                    ])
                            }, _toDisplayString(transaction?.status), 3)
                          ]),
                          _createElementVNode("td", _hoisted_35, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                      'inline-flex whitespace-nowrap items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
                      transaction?.status === 'success'
                        ? 'bg-green-100 text-green-800'
                        : transaction?.status === 'pending'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-red-100 text-red-800'
                    ])
                            }, _toDisplayString(transaction?.status_description.substring(0, 33  ) + '...'), 3)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, " Showing " + _toDisplayString(((currentPage.value - 1) * itemsPerPage.value) + 1) + " to " + _toDisplayString(Math.min(currentPage.value * itemsPerPage.value, _unref(transactions).length)) + " of " + _toDisplayString(_unref(transactions).length) + " results ", 1),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_unref(Button), {
                    size: "sm",
                    variant: "outline",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage(currentPage.value - 1))),
                    disabled: currentPage.value === 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ChevronLeft), { class: "h-4 w-4" }),
                      _cache[6] || (_cache[6] = _createTextVNode(" Previous ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createElementVNode("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
                      return _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                        key: page,
                        size: "sm",
                        variant: page === currentPage.value ? 'default' : 'outline',
                        onClick: ($event: any) => (goToPage(page)),
                        class: "min-w-[40px]"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(page), 1)
                        ]),
                        _: 2
                      }, 1032, ["variant", "onClick"])), [
                        [_vShow, page === 1 || page === totalPages.value || Math.abs(page - currentPage.value) <= 1]
                      ])
                    }), 128))
                  ]),
                  _createVNode(_unref(Button), {
                    size: "sm",
                    variant: "outline",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(currentPage.value + 1))),
                    disabled: currentPage.value === totalPages.value
                  }, {
                    default: _withCtx(() => [
                      _cache[7] || (_cache[7] = _createTextVNode(" Next ", -1)),
                      _createVNode(_unref(ChevronRight), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                class: "h-24 w-24 text-gray-300 mb-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5",
                  d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                })
              ], -1),
              _createElementVNode("h3", { class: "text-lg font-semibold text-gray-700 mb-2" }, "No Transactions Found", -1),
              _createElementVNode("p", { class: "text-gray-500 text-sm" }, "There are no transactions to display.", -1)
            ]))]))
  ]))
}
}

})